<script>
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';
import GenericDataTable from '../../components/generic/GenericDataTable.vue'

import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';

export default{
  setup: () => ({ v$: useVuelidate() }),
  props: ['vesselProtocolId', 'fiscalDestination', 'isDisabled'],
  emits: ['updateReferenceDate', 'updateReportData'],
  components: {
    Button,
    ResponsiveButton,
    GenericDataTable,
    GenericCustomAutocompleteV2
},
  data(){
    return {
      data: {},
      dataInfo: {},
      customsInformation: {},
      addValueReviewDialogVisible: false,
      addIncomingGoodsManifestDialogVisible: false,
      addExtraCEEGoodsDestinationsDialogVisible: false,
      addCEEGoodsDestinationsDialogVisible: false,
      newValueReview: {},
      newIncomingGoodsManifest: {},
      newExtraCEEGoodsDestination: {},
      newCEEGoodsDestination: {},
      filters: [],
      filtersCEE: [],
      filtersExtraCEE: [],
      filtersIncomingGoodsManifest: [],
      newExtraCEEGoodsDestinationSubmitted: false,
      newCEEGoodsDestinationSubmitted: false,
      newValueReviewSubmitted: false,
      newIncomingGoodsManifestSubmitted: false,
    }
  },
  validations(){
    return {
      customsInformation: {},
      newValueReview: {
        billCode: {required},
      },
      newExtraCEEGoodsDestination: {
        idCountry: {required},
        quantity: {required}
      },
      newCEEGoodsDestination: {
        idCountry: {required},
        quantity: {required}
      },
      newIncomingGoodsManifest: {
        number: {required},
        date: {required},
        quantity: {required}
      },
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.config = config.getConfiguration('VesselProtocol');
    if(this.isDisabled){
      this.config.valueReviewTable.enableDelete = false;
      this.config.incomingGoodsManifestTable.enableDelete = false;
      this.config.extraCEEGoodsDestinationsTable.enableDelete = false;
      this.config.CEEGoodsDestinationsTable.enableDelete = false;
    }
  },
  mounted(){
    this.loadData();
  },
  watch: {
    addExtraCEEGoodsDestinationsDialogVisible(newValue){
      if(!newValue){
        this.newExtraCEEGoodsDestinationSubmitted = false;
        this.newExtraCEEGoodsDestination = {}
      }
    },
    addCEEGoodsDestinationsDialogVisible(newValue){
      if(!newValue){
        this.newCEEGoodsDestinationSubmitted = false;
        this.newCEEGoodsDestination = {}
      }
    },
    addValueReviewDialogVisible(newValue){
      if(!newValue){
        this.newValueReviewSubmitted = false;
        this.newValueReview = {}
      }
    },
    addIncomingGoodsManifestDialogVisible(newValue){
      if(!newValue){
        this.newIncomingGoodsManifestSubmitted = false;
        this.newIncomingGoodsManifest = {}
      }
    },
    isDisabled(newValue){
      if(!newValue){
        this.config.valueReviewTable.enableDelete = true;
        this.config.incomingGoodsManifestTable.enableDelete = true;
        this.config.extraCEEGoodsDestinationsTable.enableDelete = true;
        this.config.CEEGoodsDestinationsTable.enableDelete = true;      
      }
    }
  },
  methods: {
    loadData(){
      this.filters = [
        {
          operator: 'eq',
          value: this.vesselProtocolId,
          property: 'IdVesselProtocol'
        }
      ];
      let params = {
          filter: JSON.stringify(this.filters),
      }
      Service.getVesselProtocolCustomsInformation(params, ({success, data, notFound, message}) => {
        
        if(success){
          this.customsInformation = data[0];
          this.config.customsInformation.fields.notice.forEach((item) => item.type === 'date' && (this.customsInformation[item.name] = this.customsInformation[item.name] ? new Date(this.utils.dateToCurrentTimeZone(this.customsInformation[item.name] || undefined)) : null ))
          this.config.customsInformation.fields.final.forEach((item) => item.type === 'date' && (this.customsInformation[item.name] = this.customsInformation[item.name] ? new Date(this.utils.dateToCurrentTimeZone(this.customsInformation[item.name] || undefined)) : null ))
          this.config.customsInformation.fields.incomingGoodsManifest.forEach((item) => item.type === 'date' && (this.customsInformation[item.name] = this.customsInformation[item.name] ? new Date(this.utils.dateToCurrentTimeZone(this.customsInformation[item.name] || undefined)) : null ))
          this.getReferenceDate();
          this.$emit('updateReportData', this.customsInformation);
        } else if(!notFound){
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })

      this.$refs.valueReviewTable.filterFromView(this.filters);

      this.filtersExtraCEE = [
        {
          operator: 'eq',
          value: this.vesselProtocolId,
          property: 'IdVesselProtocol'
        }
      ];
      this.filtersExtraCEE.push({
        operator: 'eq',
        value: 'EST',
        property: 'CountryFlag'
      });
      
      this.$refs.extraCEEGoodsDestinationsTable.filterFromView(this.filtersExtraCEE);

      this.filtersCEE = [
        {
          operator: 'eq',
          value: this.vesselProtocolId,
          property: 'IdVesselProtocol'
        }
      ];
      this.filtersCEE.push({
        operator: 'eq',
        value: 'UE',
        property: 'CountryFlag'
      });
      this.$refs.CEEGoodsDestinationsTable.filterFromView(this.filtersCEE);

      this.filtersIncomingGoodsManifest = [
        {
          operator: 'eq',
          value: this.vesselProtocolId,
          property: 'IdVesselProtocol'
        }
      ];
      this.$refs.incomingGoodsManifestTable.filterFromView(this.filtersIncomingGoodsManifest);
    },
    saveCustomsInformation(){
      this.customsInformation.idVesselProtocol = this.vesselProtocolId;
      if(this.customsInformation.id){
        Service.updateVesselProtocolCustomsInformation(this.customsInformation, ({success, message}) => {
        if(success){
          this.loadData();
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        }else{
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
      } else {
        Service.addVesselProtocolCustomsInformation(this.customsInformation, ({success, data, message}) => {
        if(success){
          this.customsInformation.id = data.id;
          this.loadData();
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        }else{
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
      }
    },
    addValueReview(valid){
      this.newValueReviewSubmitted = true;
      if(valid){
        this.newValueReview.idVesselProtocol = this.vesselProtocolId;
        Service.addValueReviewVesselProtocol(this.newValueReview, ({success, message}) => {
          this.addValueReviewDialogVisible = false;
          if(success){
            this.$refs.valueReviewTable.filterFromView(this.filters);
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    },
    addIncomingGoodsManifest(valid){
      this.newIncomingGoodsManifestSubmitted = true;
      if(valid){
        this.newIncomingGoodsManifest.idVesselProtocol = this.vesselProtocolId;
        Service.addIncomingGoodsManifestVesselProtocol(this.newIncomingGoodsManifest, ({success, message}) => {
          this.addIncomingGoodsManifestDialogVisible = false;
          if(success){
            this.$refs.incomingGoodsManifestTable.filterFromView(this.filters);
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    },
    getReferenceDate(){
      let date = null;
      if(this.fiscalDestination === 'EST'){
        date = (this.customsInformation.registerDate || this.customsInformation.noticeECustomBillDate)
      }

      this.$emit('updateReferenceDate', date);
    },
    importCustomsInformation(){
      const billCode = this.customsInformation.finalECustomBillCode || this.customsInformation.noticeECustomBillCode;

      if(billCode){
        Service.getVesselProtocolCustomsInformationBollaAida(billCode, ({success, data, message}) => {
          if(success){
            this.customsInformation.finalECustomBillCode = data.billCode;
            this.customsInformation.finalECustomBillDate = data.billDate != null ? new Date(this.utils.dateToCurrentTimeZone(data.billDate)) : null;

            this.customsInformation.weight = data.quantity;
            this.customsInformation.registerType = data.registration;
            this.customsInformation.registerDate = data.registrationDate != null ?  new Date(this.utils.dateToCurrentTimeZone(data.registrationDate)) : null;
            this.customsInformation.eRegistrationCode = data.registrationNumber;
            this.customsInformation.field22 = data.field22;
            this.customsInformation.field33 = data.field33;
            this.customsInformation.statisticValue = data.field46;
            this.customsInformation.totalTaxAmount = data.field47;
            this.customsInformation.a93Number = data.a93Number + "";
            this.customsInformation.periodicPaymentExpiration = data.a93Date != null ? new Date(this.utils.dateToCurrentTimeZone(data.a93Date)) : null;
            this.customsInformation.mrn = data.mrn;
            this.customsInformation.customScheme = data.customClearanceProcedure;
            this.customsInformation.releaseCode = data.releaseCode;

          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    },
    addExtraCEEGoodsDestinations(valid){
      this.newExtraCEEGoodsDestinationSubmitted = true;

      if(valid){
        this.newExtraCEEGoodsDestination.idVesselProtocol = this.vesselProtocolId;
    
        Service.addGoodsDestinationVesselProtocol(this.newExtraCEEGoodsDestination, ({success, message}) => {
          this.addExtraCEEGoodsDestinationsDialogVisible = false;
          if(success){
            this.$refs.extraCEEGoodsDestinationsTable.filterFromView(this.filtersExtraCEE);
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    },
    addCEEGoodsDestinations(valid){
      this.newCEEGoodsDestinationSubmitted = true;

      if(valid){
        this.newCEEGoodsDestination.idVesselProtocol = this.vesselProtocolId;

        Service.addGoodsDestinationVesselProtocol(this.newCEEGoodsDestination, ({success, message}) => {
          this.addCEEGoodsDestinationsDialogVisible = false;
          if(success){
            this.$refs.CEEGoodsDestinationsTable.filterFromView(this.filtersCEE);
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    },
  },
}

</script>

<template>
  <main>
    <Dialog :header="$t('vesselProtocol.addValueReview')" v-model:visible="addValueReviewDialogVisible" :style="{width: '500px'}" :modal="true">
      <div class="grid">
          <template v-for="field in config.valueReviewTable.columns" :key="field.name">
            <div class="col-12 lg:col-6" v-if="!field.formHide">
              <label :class="{'p-error':v$.newValueReview[field.name] && v$.newValueReview[field.name].$invalid && newValueReviewSubmitted}" :for="field.name" >{{ $t(field.label) }}</label>
              <InputText 
                v-if="field.type === 'string'"
                :class="{'p-invalid':v$.newValueReview[field.name] && v$.newValueReview[field.name].$invalid && newValueReviewSubmitted}"
                :id="field.name"
                type="text"
                v-model="newValueReview[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <Calendar 
                dateFormat="dd/mm/yy" 
                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                v-if="field.type === 'date'"
                :class="{'p-invalid':v$.newValueReview[field.name] && v$.newValueReview[field.name].$invalid && newValueReviewSubmitted}"
                :id="field.name"
                v-model="newValueReview[field.name]"
                class="w-full mt-1" />
              <InputNumber
                v-if="field.type === 'number'"
                :class="{'p-invalid':v$.newValueReview[field.name] && v$.newValueReview[field.name].$invalid && newValueReviewSubmitted}"
                :id="field.name"
                v-model="newValueReview[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <div v-if="(v$.newValueReview[field.name] && v$.newValueReview[field.name].$invalid && newValueReviewSubmitted) || v$.newValueReview[field.name] && v$.newValueReview[field.name].$pending.$response">
                <small class="p-error" v-for="error in v$.newValueReview[field.name] && v$.newValueReview[field.name].$silentErrors" :key="error.$validator" >
                    {{error.$message}}
                </small>
              </div>
            </div>
          </template>
          <div class="col-12 text-right">
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" @click="addValueReviewDialogVisible = false" class="p-button-outlined p-button-sm" />
            <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="addValueReview(!v$.newValueReview.$invalid)" class="p-button-outlined p-button-sm ml-2" />
          </div>
      </div>
    </Dialog>
    <Dialog :header="$t('vesselProtocol.addIncomingGoodsManifest')" v-model:visible="addIncomingGoodsManifestDialogVisible" :style="{width: '500px'}" :modal="true">
      <div class="grid">
          <template v-for="field in config.incomingGoodsManifestTable.columns" :key="field.name">
            <div class="col-12 lg:col-6" v-if="!field.formHide">
              <label :class="{'p-error':v$.newIncomingGoodsManifest[field.name] && v$.newIncomingGoodsManifest[field.name].$invalid && newIncomingGoodsManifestSubmitted}" :for="field.name" >{{ $t(field.label) }}</label>
              <InputText 
                v-if="field.type === 'string'"
                :class="{'p-invalid':v$.newIncomingGoodsManifest[field.name] && v$.newIncomingGoodsManifest[field.name].$invalid && newIncomingGoodsManifestSubmitted}"
                :id="field.name"
                type="text"
                v-model="newIncomingGoodsManifest[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <Calendar 
                dateFormat="dd/mm/yy" 
                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                v-if="field.type === 'date'"
                :class="{'p-invalid':v$.newIncomingGoodsManifest[field.name] && v$.newIncomingGoodsManifest[field.name].$invalid && newIncomingGoodsManifestSubmitted}"
                :id="field.name"
                v-model="newIncomingGoodsManifest[field.name]"
                class="w-full mt-1" />
              <InputNumber
                v-if="field.type === 'number'"
                :class="{'p-invalid':v$.newIncomingGoodsManifest[field.name] && v$.newIncomingGoodsManifest[field.name].$invalid && newIncomingGoodsManifestSubmitted}"
                :id="field.name"
                v-model="newIncomingGoodsManifest[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <div v-if="(v$.newIncomingGoodsManifest[field.name] && v$.newIncomingGoodsManifest[field.name].$invalid && newIncomingGoodsManifestSubmitted) || v$.newIncomingGoodsManifest[field.name] && v$.newIncomingGoodsManifest[field.name].$pending.$response">
                <small class="p-error" v-for="error in v$.newIncomingGoodsManifest[field.name] && v$.newIncomingGoodsManifest[field.name].$silentErrors" :key="error.$validator" >
                    {{error.$message}}
                </small>
              </div>
            </div>
          </template>
          <div class="col-12 text-right">
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" @click="addIncomingGoodsManifestDialogVisible = false" class="p-button-outlined p-button-sm" />
            <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="addIncomingGoodsManifest(!v$.newIncomingGoodsManifest.$invalid)" class="p-button-outlined p-button-sm ml-2" />
          </div>
      </div>
    </Dialog>
    <Dialog :header="$t('vesselProtocol.addExtraCEEGoodsDestination')" v-model:visible="addExtraCEEGoodsDestinationsDialogVisible" :style="{width: '500px'}" :modal="true" >
      <div class="grid">
          <template v-for="field in config.extraCEEGoodsDestinationsTable.columns" :key="field.name">
            <div class="col-12 lg:col-6" v-if="!field.formHide">
              <label :class="{'p-error':v$.newExtraCEEGoodsDestination[field.name] && v$.newExtraCEEGoodsDestination[field.name].$invalid && newExtraCEEGoodsDestinationSubmitted}" :for="field.name" >{{ $t(field.label) }}</label>
              <InputText 
                v-if="field.type === 'string'"
                :class="{'p-invalid':v$.newExtraCEEGoodsDestination[field.name] && v$.newExtraCEEGoodsDestination[field.name].$invalid && newExtraCEEGoodsDestinationSubmitted}"
                :id="field.name"
                type="text"
                v-model="newExtraCEEGoodsDestination[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <Calendar 
                dateFormat="dd/mm/yy" 
                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                v-if="field.type === 'date'"
                :class="{'p-invalid':v$.newExtraCEEGoodsDestination[field.name] && v$.newExtraCEEGoodsDestination[field.name].$invalid && newExtraCEEGoodsDestinationSubmitted}"
                :id="field.name"
                v-model="newExtraCEEGoodsDestination[field.name]"
                class="w-full mt-1" />
              <InputNumber
                v-if="field.type === 'number'"
                :class="{'p-invalid':v$.newExtraCEEGoodsDestination[field.name] && v$.newExtraCEEGoodsDestination[field.name].$invalid && newExtraCEEGoodsDestinationSubmitted}"
                :id="field.name"
                v-model="newExtraCEEGoodsDestination[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <GenericCustomAutocompleteV2
                v-if="field.type === 'select'"
                :class="{'p-invalid':v$.newExtraCEEGoodsDestination[field.name] && v$.newExtraCEEGoodsDestination[field.name].$invalid && newExtraCEEGoodsDestinationSubmitted}"
                :id="field.name"
                :api="field.selectApi"
                :format="field.selectFormat"
                v-model="newExtraCEEGoodsDestination[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <div v-if="(v$.newExtraCEEGoodsDestination[field.name] && v$.newExtraCEEGoodsDestination[field.name].$invalid && newExtraCEEGoodsDestinationSubmitted) || v$.newExtraCEEGoodsDestination[field.name] && v$.newExtraCEEGoodsDestination[field.name].$pending.$response">
                <small class="p-error" v-for="error in v$.newExtraCEEGoodsDestination[field.name] && v$.newExtraCEEGoodsDestination[field.name].$silentErrors" :key="error.$validator" >
                    {{error.$message}}
                </small>
              </div>
            </div>
          </template>
          <div class="col-12 text-right">
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" @click="addExtraCEEGoodsDestinationsDialogVisible = false" class="p-button-outlined p-button-sm" />
            <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="addExtraCEEGoodsDestinations(!v$.newExtraCEEGoodsDestination.$invalid)" class="p-button-outlined p-button-sm ml-2" />
          </div>
      </div>
    </Dialog>
    <Dialog :header="$t('vesselProtocol.addCEEGoodsDestination')" v-model:visible="addCEEGoodsDestinationsDialogVisible" :style="{width: '500px'}" :modal="true">
      <div class="grid">
          <template v-for="field in config.CEEGoodsDestinationsTable.columns" :key="field.name">
            <div class="col-12 lg:col-6" v-if="!field.formHide">
              <label :class="{'p-error':v$.newCEEGoodsDestination[field.name] && v$.newCEEGoodsDestination[field.name].$invalid && newCEEGoodsDestinationSubmitted}" :for="field.name" >{{ $t(field.label) }}</label>
              <InputText 
                v-if="field.type === 'string'"
                :class="{'p-invalid':v$.newCEEGoodsDestination[field.name] && v$.newCEEGoodsDestination[field.name].$invalid && newCEEGoodsDestinationSubmitted}"
                :id="field.name"
                type="text"
                v-model="newCEEGoodsDestination[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <Calendar 
                dateFormat="dd/mm/yy" 
                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                v-if="field.type === 'date'"
                :class="{'p-invalid':v$.newCEEGoodsDestination[field.name] && v$.newCEEGoodsDestination[field.name].$invalid && newCEEGoodsDestinationSubmitted}"
                :id="field.name"
                v-model="newCEEGoodsDestination[field.name]"
                class="w-full mt-1" />
              <InputNumber
                v-if="field.type === 'number'"
                :class="{'p-invalid':v$.newCEEGoodsDestination[field.name] && v$.newCEEGoodsDestination[field.name].$invalid && newCEEGoodsDestinationSubmitted}"
                :id="field.name"
                v-model="newCEEGoodsDestination[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <GenericCustomAutocompleteV2
                v-if="field.type === 'select'"
                :class="{'p-invalid':v$.newCEEGoodsDestination[field.name] && v$.newCEEGoodsDestination[field.name].$invalid && newCEEGoodsDestinationSubmitted}"
                :id="field.name"
                :api="field.selectApi"
                :format="field.selectFormat"
                v-model="newCEEGoodsDestination[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <div v-if="(v$.newCEEGoodsDestination[field.name] && v$.newCEEGoodsDestination[field.name].$invalid && newCEEGoodsDestinationSubmitted) || v$.newCEEGoodsDestination[field.name] && v$.newCEEGoodsDestination[field.name].$pending.$response">
                <small class="p-error" v-for="error in v$.newCEEGoodsDestination[field.name] && v$.newCEEGoodsDestination[field.name].$silentErrors" :key="error.$validator" >
                    {{error.$message}}
                </small>
              </div>
            </div>
          </template>
          <div class="col-12 text-right">
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" @click="addCEEGoodsDestinationsDialogVisible = false" class="p-button-outlined p-button-sm" />
            <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="addCEEGoodsDestinations(!v$.newCEEGoodsDestination.$invalid)" class="p-button-outlined p-button-sm ml-2" />
          </div>
      </div>
    </Dialog>
    <div class="grid">
      <div class="col-12">
        <Toolbar>
          <template #start>
            <Button :label="$t('btn.save')" icon="pi pi-save" @click="saveCustomsInformation" class="mr-2" :disabled="!uiPermissions('vesselProtocolCustomsInformationSaveButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolCustomsInformationSaveButton').isHidden" />
            <Button :label="$t('btn.import')" icon="pi pi-upload" @click="importCustomsInformation" :disabled="!uiPermissions('vesselProtocolCustomsInformationSaveButton').isEnabled || isDisabled" class="p-button-success"/>
          </template>
        </Toolbar>
      </div>
      <div class="col-12 lg:col-6">
        <span class="title">{{ $t('vesselProtocol.noticeECustomBill') }}</span>
      </div>
      <div class="col-12 lg:col-6 text-right">
        <p><b>{{ $t('vesselProtocol.customsExchangeRate') + ': ' +  (customsInformation?.['customExchangeRate'] ?? "-")}}</b></p>
      </div>
      <div class="col-12">
        <div class="grid">
          <div class="col-12 lg:col-3" v-for="field in config.customsInformation.fields.notice" :key="field.name">
            <label :class="{'p-error':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}" :for="field.name" >{{ $t('vesselProtocol.' + field.label) }}</label>
            <InputText 
              v-if="field.type === 'string'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              type="text"
              v-model="customsInformation[field.name]"
              class="w-full p-inputtext-sm mt-1" />
            <Calendar 
              dateFormat="dd/mm/yy" 
              :showIcon="true" :showButtonBar="true" :yearNavigator="true"
              v-if="field.type === 'date'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              v-model="customsInformation[field.name]"
              class="w-full mt-1" />
            <InputNumber
              v-if="field.type === 'number'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              v-model="customsInformation[field.name]"
              class="w-full p-inputtext-sm mt-1" />
            <div v-if="(v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted) || v$.customsInformation[field.name] && v$.customsInformation[field.name].$pending.$response">
              <small class="p-error" v-for="error in v$.customsInformation[field.name] && v$.customsInformation[field.name].$silentErrors" :key="error.$validator" >
                  {{error.$message}}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <span class="title">{{ $t('vesselProtocol.finalECustomBill') }}</span>
      </div>
      <div class="col-12">
        <div class="grid">
          <div class="col-12 lg:col-3" v-for="field in config.customsInformation.fields.final" :key="field.name">
            <label :class="{'p-error':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}" :for="field.name" >{{ $t('vesselProtocol.' + field.label) }}</label>
            <InputText 
              v-if="field.type === 'string'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              type="text"
              v-model="customsInformation[field.name]"
              class="w-full p-inputtext-sm mt-1" />
            <Calendar 
              dateFormat="dd/mm/yy" 
              :showIcon="true" :showButtonBar="true" :yearNavigator="true"
              v-if="field.type === 'date'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              v-model="customsInformation[field.name]"
              class="w-full mt-1" />
            <InputNumber
              v-if="field.type === 'number'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              v-model="customsInformation[field.name]"
              class="w-full p-inputtext-sm mt-1" />
            <InputNumber
              v-if="field.type === 'decimal'"
              :maxFractionDigits="field.digits"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              v-model="customsInformation[field.name]"
              class="w-full p-inputtext-sm mt-1" />
            <div v-if="(v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted) || v$.customsInformation[field.name] && v$.customsInformation[field.name].$pending.$response">
              <small class="p-error" v-for="error in v$.customsInformation[field.name] && v$.customsInformation[field.name].$silentErrors" :key="error.$validator" >
                  {{error.$message}}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <span class="title">{{ $t('vesselProtocol.incomingGoodsManifest') }}</span>
      </div>
      <div class="col-12">
        <div class="grid">
          <div class="col-12 lg:col-3" v-for="field in config.customsInformation.fields.incomingGoodsManifest" :key="field.name">
            <label :class="{'p-error':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}" :for="field.name" >{{ $t('vesselProtocol.' + field.label) }}</label>
            <InputText 
              v-if="field.type === 'string'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              type="text"
              v-model="customsInformation[field.name]"
              class="w-full p-inputtext-sm mt-1" />
            <Calendar 
              dateFormat="dd/mm/yy" 
              :showIcon="true" :showButtonBar="true" :yearNavigator="true"
              v-if="field.type === 'date'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              v-model="customsInformation[field.name]"
              class="w-full mt-1" />
            <InputNumber
              v-if="field.type === 'number'"
              :class="{'p-invalid':v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted}"
              :id="field.name"
              v-model="customsInformation[field.name]"
              class="w-full p-inputtext-sm mt-1" />
            <div v-if="(v$.customsInformation[field.name] && v$.customsInformation[field.name].$invalid && customsInformationSubmitted) || v$.customsInformation[field.name] && v$.customsInformation[field.name].$pending.$response">
              <small class="p-error" v-for="error in v$.customsInformation[field.name] && v$.customsInformation[field.name].$silentErrors" :key="error.$validator" >
                  {{error.$message}}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-right">
        <Button :label="$t('btn.save')" icon="pi pi-save" @click="saveCustomsInformation" class="mr-2" :disabled="!uiPermissions('vesselProtocolCustomsInformationSaveButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolCustomsInformationSaveButton').isHidden" />
      </div>
    </div>
    <div class="grid">
      <div class="col-12 mt-5 mb-2">
        <span class="title">{{ $t('vesselProtocol.valueReviewBillDeclaration') }}</span>
        <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="addValueReviewDialogVisible = true" :disabled="!uiPermissions('vesselProtocolCustomsInformationAddValueReviewButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolCustomsInformationAddValueReviewButton').isHidden" />
        <div>
          <GenericDataTable :configuration="config.valueReviewTable" ref="valueReviewTable"/>
        </div>
      </div>
      <div class="col-12 mt-5 mb-2">
        <span class="title">{{ $t('vesselProtocol.incomingGoodsManifest') }}</span>
        <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="addIncomingGoodsManifestDialogVisible = true" :disabled="!uiPermissions('vesselProtocolCustomsInformationAddValueReviewButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolCustomsInformationAddValueReviewButton').isHidden" />
        <div>
          <GenericDataTable :configuration="config.incomingGoodsManifestTable" ref="incomingGoodsManifestTable"/>
        </div>
      </div>
      <div class="col-12 mt-5 mb-2">
        <span class="title">{{ $t('vesselProtocol.extraCEEGoodsDestinations') }}</span>
        <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="addExtraCEEGoodsDestinationsDialogVisible = true" :disabled="!uiPermissions('vesselProtocolCustomsInformationAddExtraCEEGoodsDestinationsButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolCustomsInformationAddExtraCEEGoodsDestinationsButton').isHidden" />
        <GenericDataTable :configuration="config.extraCEEGoodsDestinationsTable" :name="'extraCEEGoodsDestinationsTable'" ref="extraCEEGoodsDestinationsTable"/>
      </div>
      <div class="col-12 mt-5">
        <span class="title">{{ $t('vesselProtocol.CEEGoodsDestinations') }}</span>
        <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="addCEEGoodsDestinationsDialogVisible = true" :disabled="!uiPermissions('vesselProtocolCustomsInformationAddCEEGoodsDestinationsButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolCustomsInformationAddCEEGoodsDestinationsButton').isHidden" />
        <GenericDataTable :configuration="config.CEEGoodsDestinationsTable" :name="'CEEGoodsDestinationsTable'" ref="CEEGoodsDestinationsTable"/>
      </div>
    </div>
  </main>
</template>

<style scoped>

.title{
  font-size: large;
}

.p-datatable-flex-scrollable {
  height: initial !important;
  flex: initial !important;
}
</style>